<div class="search-bar-container">
  <mat-form-field subscriptSizing="dynamic" class="mat-form-field-dropdown searchbar-sm"
    [ngClass]="{ 'searchbar-sm': isDetailView }">
    <mat-select [(ngModel)]="selectedField" (selectionChange)="onFieldChange()">
      @for (option of fields; track option) {
        <mat-option [value]="option.value">
          {{ option.displayName }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if(selectedField === 'SubmissionCreateDate' || selectedField === 'SoldDate') {
    <mat-form-field class="mat-form-field-datepicker">
      <input matInput [(ngModel)]="searchText" (keydown.enter)="applyFilter(true)" [matDatepicker]="picker" (dateChange)="onDateChange($event)">
      @if (!hasActiveDateSearch) {
        <mat-icon matSuffix class="search-suffix-icon">search</mat-icon>
      }
      <mat-datepicker-toggle matIconSuffix [for]="picker" [disableRipple]="true" ></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      @if (hasActiveDateSearch) {
        <button matSuffix class="clear-btn" mat-icon-button aria-label="Clear" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  } @else {
    <mat-form-field subscriptSizing="dynamic" class="mat-form-field-search">
      <input matInput [(ngModel)]="searchText" (keydown.enter)="applyFilter()" />
      <mat-icon matSuffix class="search-suffix-icon">search</mat-icon>
      @if (searchText) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  }
</div>